import React, {useState} from 'react'
import tw, { styled } from 'twin.macro'
import {Input} from 'baseui/input'
import {Block} from 'baseui/block'

import RightArrowIcon from './rightArrow.svg'
import SuccessCircleIcon from './successCircle.svg'

import useHobspot from './useHobspot'

type Props = {
  status?: any
  message?: any
}

enum STATUS {
  default = 'default',
  warning = 'warning',
  success = 'success',
}

const regexEmail = /\S+@\S+\.\S+/

function isEmail(email: string) {
  return regexEmail.test(email)
}

const TextGR14 = styled(Block)`
  ${tw`font-primary`}
  font-size: 14px;
  line-height: 16px;
`

const EmailInput: React.FC<Props> = () => {
  const [textValue, setTextValue] = useState<string>('')
  const [status, setStatus] = useState<STATUS>(STATUS.default)

  const {data, isLoading, isError, handleSubmit} = useHobspot(textValue)

  const isSuccess = data?.inlineMessage === 'Thanks for submitting the form.'

  function onChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setTextValue(e.target.value)
  }

  function checkEmail() {
    const isOk = isEmail(textValue)
    setStatus(STATUS.default)

    if (!isOk) {
      setStatus(STATUS.warning)
    }

    return isOk
  }

  function onKeyPress(e: React.KeyboardEvent) {
    if (e.key === 'Enter') {
      sendEmail()
    }
  }

  async function sendEmail() {
    if (checkEmail()) {
      try {
        handleSubmit()
      } catch (e) {
        console.error(e)
      }
    }
  }

  return (
    <div style={{width: '100%'}}>
      <Input
        onKeyPress={onKeyPress}
        onChange={onChange}
        value={textValue}
        endEnhancer={
          isSuccess ? (
            <SuccessCircleIcon width="22px" height="22px" />
          ) : (
            <Block onClick={sendEmail} display="flex" alignItems={'center'}>
              <RightArrowIcon />
            </Block>
          )
        }
        placeholder="Enter your email address"
        overrides={{
          Root: {
            style: () => ({
              ...tw`w-full lg:min-w-[300px]`,
              height: '40px',
              marginBottom: '10px',
              borderTopColor: '#1FCFAA',
              borderRightColor: '#1FCFAA',
              borderBottomColor: '#1FCFAA',
              borderLeftColor: '#1FCFAA',
              borderTopWidth: '1px',
              borderRightWidth: '1px',
              borderBottomWidth: '1px',
              borderLeftWidth: '1px',
              backgroundColor: 'transparent',
            }),
          },
          InputContainer: {
            style: () => ({
              backgroundColor: 'transparent',
            }),
          },
          Input: {
            style: () => ({
              ...tw`font-primary`,
              fontSize: '14px',
              lineHeight: '16px',
            }),
          },
          EndEnhancer: {
            style: () => ({
              backgroundColor: 'transparent',
            }),
          },
        }}
      />

      {isLoading && <TextGR14>Sending...</TextGR14>}

      {isError && <TextGR14>Subscribe Fail</TextGR14>}

      {status === STATUS.warning && (
        <TextGR14>Please enter the right email address</TextGR14>
      )}

      {isSuccess && <TextGR14>Thanks for subscribing!</TextGR14>}
    </div>
  )
}

export default React.memo(EmailInput)
